export const getLeaderBoardData = (payload?: any) => ({
    type: "@saga/GET_LEADER_BOARD_DATA",
    payload
});

